import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Box,
    Card,
    Button,
    makeStyles,
    Container,
    Divider,
    CardContent,
    CardHeader,
    Grid,
    TextField,
    MenuItem,
    InputLabel,
    Checkbox,
    Typography
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import * as Yup from "yup";
import { LoadingComponent } from 'src/utils/newLoader';
import { Formik } from 'formik';
import { useAlert } from "react-alert";
import PageHeader from 'src/views/Common/PageHeader';
import MaterialTable from "material-table";
import moment from 'moment';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    colorCancel: {
        backgroundColor: "red",
    },
    colorRecordAndNew: {
        backgroundColor: "#FFBE00"
    },
    colorRecord: {
        backgroundColor: "green",
    },
    colorReject: {
        backgroundColor: "red",
    },
    colorApprove: {
        backgroundColor: "green",
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));

const screenCode = 'EMPLOYEELEAVEFORMNEW';

export default function EmployeeLeaveFormListing(props) {
    const [open, setOpen] = useState(false);
    const [openApprove, setOpenApprove] = useState(false);
    const [title, setTitle] = useState("Employee Leave Requests");
    const classes = useStyles();
    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [leaveFormData, setLeaveFormData] = useState({
        groupID: 0,
        factoryID: 0,
        registrationNumber: ''
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
        isLeaveRequestApproveReject: false
    });
    const [leaveRequestData, setLeaveRequestData] = useState([]);
    const [found, setFound] = useState([]);
    const navigate = useNavigate();
    const alert = useAlert();
    const [selectedRows, setSelectedRows] = useState([]);
    const [checkAll, setCheckAll] = useState(false);
    let encryptedID = "";

    useEffect(() => {
        trackPromise(getPermission(), getGroupsForDropdown());
    }, []);

    useEffect(() => {
        sessionStorage.removeItem('leavelisting_page_filters');
    }, []);

    useEffect(() => {
        if (leaveFormData.groupID > 0) {
            trackPromise(getFactoriesForDropDown());
        }
    }, [leaveFormData.groupID]);

    useEffect(() => {
        setLeaveRequestData([]);
    }, [leaveFormData.groupID, leaveFormData.factoryID, leaveFormData.registrationNumber]);

    const handleClick = () => {
        encryptedID = btoa('0');
        navigate('/app/LeaveForm/addEdit/' + encryptedID);
    }

    const handleOpenDialog = () => {
        setOpen(true);
    };

    const handleOpenDialogApprove = () => {
        setOpenApprove(true);
    };

    const handleCloseDialog = () => {
        setOpen(false);
    };

    const handleCloseDialogApprove = () => {
        setOpenApprove(false);
    };

    const handleReject = async () => {
        setOpen(false);
        let array = [];
        
        selectedRows.forEach((x) => {
            if (x.pending > 0) {
                array.push({
                    leaveRefNo: x.leaveRefNo,
                    ModifiedBy: parseInt(tokenService.getUserIDFromToken())
                });
            }
        });
        
        if (array.length === 0) {
            alert.error("No pending leave requests to reject");
            return;
        }
        
        let model = {
            approve: array 
        };
        
        const response = await services.SaveRejectedLeaveRequest(model);
        
        if (response.statusCode === "Success") {
            alert.success(response.message);
            setSelectedRows([]);
            getAllLeaveRequestDetailsByGroupFactory();
        } else {
            alert.error(response.message || "Failed to reject leave requests");
        }
    }

    const EditLeaveFormData = (rowData) => {
        const idToUse = rowData?.leaveRefNo || 
                        rowData?.employeeLeaveRequestID || 
                        rowData?.leaveRequestID ||
                        rowData?.id || 
                        rowData?.requestID ||
                        rowData?.refNo ||
                        rowData?.referenceNo;
        
        if (!idToUse || idToUse === 0 || idToUse === '0') {
            alert.error('Invalid leave reference number - cannot edit this record');
            return;
        }
        
        let encryptedID = btoa(idToUse.toString());
        
        let filtermodel = {
            groupID: parseInt(leaveFormData.groupID),
            factoryID: parseInt(leaveFormData.factoryID),
            registrationNumber: leaveFormData.registrationNumber
        };
        
        sessionStorage.setItem('leavelisting_page_filters', JSON.stringify(filtermodel));
        
        const navigationPath = '/app/LeaveForm/addEdit/' + encryptedID;
        navigate(navigationPath);
    };

    async function getPermission() {
        const checkhistory = JSON.parse(sessionStorage.getItem('leavelisting_page_filters'));
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWEMPLOYEELEAVEFORM');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
        var isLeaveRequestApproveReject = permissions.find(p => p.permissionCode === 'VIEWLEAVEREQUESTAPPROVEREJECT');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
            isLeaveRequestApproveReject: isLeaveRequestApproveReject !== undefined
        });

        if (checkhistory == null) {
            setLeaveFormData({
                ...leaveFormData,
                groupID: parseInt(tokenService.getGroupIDFromToken()),
                factoryID: parseInt(tokenService.getFactoryIDFromToken())
            })
        }
        else {
            let model = {
                groupID: parseInt(checkhistory.groupID),
                factoryID: parseInt(checkhistory.factoryID),
                registrationNumber: checkhistory.registrationNumber
            }
            setLeaveFormData({
                ...leaveFormData,
                groupID: parseInt(checkhistory.groupID),
                factoryID: parseInt(checkhistory.factoryID),
                registrationNumber: checkhistory.registrationNumber
            })
            trackPromise(getPreviousLeave(model));
        }
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }

    async function getFactoriesForDropDown() {
        const factories = await services.getAllFactoriesByGroupID(leaveFormData.groupID);
        setFactories(factories);
    }

    async function getAllLeaveRequestDetailsByGroupFactory() {
        let model = {
            groupID: parseInt(leaveFormData.groupID),
            factoryID: parseInt(leaveFormData.factoryID),
            registrationNumber: leaveFormData.registrationNumber
        }
        
        const verify = await services.getAllLeaveRequestDetailsByGroupFactory(model);
        
        setLeaveRequestData([]);
        if (verify.data.length > 0) {
            const found = verify.data.filter(x => x.pending != 0);
            setFound(found);
            setLeaveRequestData(verify.data);
        }
        else {
            alert.error("No Records to Display");
        }
    }

    async function getPreviousLeave(params) {
        const verify = await services.getAllLeaveRequestDetailsByGroupFactory(params);
        setLeaveRequestData([]);
        if (verify.data.length > 0) {
            setLeaveRequestData(verify.data);
            const found = verify.data.filter(x => x.pending != 0)
            setFound(found)
        }
        else {
            alert.error("No Records to Display");
        }
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
                <Grid item md={2} xs={12}>
                    <PageHeader
                        onClick={handleClick}
                        isEdit={true}
                        toolTiptitle={"Add Leave Form"}
                    />
                </Grid>
            </Grid>
        )
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value
        setLeaveFormData({
            ...leaveFormData,
            [e.target.name]: value
        });
    }

    async function handleApproveClick() {
        setOpenApprove(false);
        let array = [];
        
        selectedRows.forEach((x) => {
            if (x.pending > 0) {
                array.push({
                    leaveRefNo: x.leaveRefNo,
                    ModifiedBy: parseInt(tokenService.getUserIDFromToken())
                });
            }
        });
        
        if (array.length === 0) {
            alert.error("No pending leave requests to approve");
            return;
        }
        
        let model = {
            approve: array
        };
        
        const response = await services.SaveApprovedLeaveRequest(model);
        
        if (response.statusCode == "Success") {
            setOpenApprove(false);
            alert.success(response.message);
            setSelectedRows([]);
            getAllLeaveRequestDetailsByGroupFactory();
        } else {
            alert.error(response.message || "Failed to approve leave requests");
        }
    }

    function handleClickAll(e) {
        let uploadDataCopy = [...selectedRows];
        if (e.target.checked) {
            leaveRequestData.forEach(x => {
                if (x.pending != 0) {
                    const isEnable = uploadDataCopy.filter((p) => p.leaveRefNo == x.leaveRefNo);
                    if (isEnable.length === 0) {
                        uploadDataCopy.push(x);
                    }
                }
            });
            setSelectedRows(uploadDataCopy);
        }
        else {
            setSelectedRows([]);
        }
    }

    const selectAll = () => {
        setCheckAll(!checkAll);
    };

    function handleClickOne(data) {
        let uploadDataCopy = [...selectedRows];
        const isEnable = uploadDataCopy.filter((p) => p.leaveRefNo == data.leaveRefNo);
        
        if (isEnable.length === 0) {
            uploadDataCopy.push(data);
        } else {
            var index = uploadDataCopy.indexOf(isEnable[0]);
            uploadDataCopy.splice(index, 1);
        }
        
        setSelectedRows(uploadDataCopy);
    }

    return (
        <Fragment>
            <LoadingComponent />
            <Page className={classes.root} title={title}>
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: leaveFormData.groupID,
                            factoryID: leaveFormData.factoryID,
                            registrationNumber: leaveFormData.registrationNumber
                        }}
                        validationSchema={
                            Yup.object().shape({
                                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required')
                            })
                        }
                        onSubmit={() => trackPromise(getAllLeaveRequestDetailsByGroupFactory())}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader
                                            title={cardTitle(title)}
                                        />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent style={{ marginBottom: "2rem" }}>
                                                <Grid container spacing={3}>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="groupID">
                                                            Group *
                                                        </InputLabel>
                                                        <TextField 
                                                            select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            fullWidth
                                                            helperText={touched.groupID && errors.groupID}
                                                            size='small'
                                                            name="groupID"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={leaveFormData.groupID}
                                                            variant="outlined"
                                                            InputProps={{
                                                                readOnly: !permissionList.isGroupFilterEnabled,
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(groups)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory *
                                                        </InputLabel>
                                                        <TextField 
                                                            select
                                                            error={Boolean(touched.factoryID && errors.factoryID)}
                                                            fullWidth
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            size='small'
                                                            name="factoryID"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={leaveFormData.factoryID}
                                                            variant="outlined"
                                                            id="factoryID"
                                                            InputProps={{
                                                                readOnly: !permissionList.isFactoryFilterEnabled,
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                                            {generateDropDownMenu(factories)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="registrationNumber">
                                                            Registration Number
                                                        </InputLabel>
                                                        <TextField
                                                            error={Boolean(touched.registrationNumber && errors.registrationNumber)}
                                                            fullWidth
                                                            helperText={touched.registrationNumber && errors.registrationNumber}
                                                            size='small'
                                                            name="registrationNumber"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={leaveFormData.registrationNumber}
                                                            variant="outlined"
                                                            id="registrationNumber"
                                                        >
                                                        </TextField>
                                                    </Grid>
                                                </Grid>
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        type="submit"
                                                    >
                                                        Search
                                                    </Button>
                                                </Box>
                                            </CardContent>
                                            {leaveRequestData.length > 0 ?
                                                <Box minWidth={1000}>
                                                    <MaterialTable
                                                        title="Multiple Actions Preview"
                                                        columns={[
                                                            { title: 'Reg.No', field: 'registrationNumber' },
                                                            { title: 'Emp.Name', field: 'employeeName' },
                                                            { title: 'Type', field: 'employeeLeaveTypeName' },
                                                            { title: 'F.Date', field: 'fromDate', render: rowData => moment(rowData.fromDate).format('YYYY-MM-DD') },
                                                            { title: 'T.Date', field: 'toDate', render: rowData => moment(rowData.toDate).format('YYYY-MM-DD') },
                                                            { title: 'Applied', field: 'noOfDays' },      
                                                            { title: 'Pending', field: 'pending' },     
                                                            { title: 'Approved', field: 'approved' },   
                                                            { title: 'Rejected', field: 'rejected' },   
                                                            {
                                                                title: (
                                                                    <label>
                                                                        {found.length > 0 ? "Select" : "Select"}
                                                                        {found.length > 0 ? (
                                                                            <Checkbox
                                                                                color="primary"
                                                                                onClick={(e) => handleClickAll(e)}
                                                                                onChange={selectAll}
                                                                                checked={(leaveRequestData.length != 0) && (selectedRows.length == leaveRequestData.filter(x => x.pending != 0).length)}
                                                                            ></Checkbox>
                                                                        ) : null}
                                                                    </label>
                                                                ),
                                                                render: rowData => {
                                                                    return (
                                                                        <Checkbox
                                                                            color="primary"
                                                                            onClick={() => handleClickOne(rowData)}
                                                                            disabled={rowData.pending == 0 ? true : false}
                                                                            checked={!(selectedRows.find((x) => x.leaveRefNo == rowData.leaveRefNo) == undefined)}
                                                                        ></Checkbox>
                                                                    );
                                                                },
                                                            }
                                                        ]}
                                                        data={leaveRequestData}
                                                        options={{
                                                            exportButton: false,
                                                            showTitle: false,
                                                            headerStyle: { textAlign: "left", height: '1%' },
                                                            cellStyle: { textAlign: "left" },
                                                            columnResizable: false,
                                                            actionsColumnIndex: -1
                                                        }}
                                                        actions={[
                                                            {
                                                                icon: 'edit',
                                                                tooltip: 'Edit Employee',
                                                                onClick: (event, rowData) => EditLeaveFormData(rowData)
                                                            }
                                                        ]}
                                                    />
                                                </Box>
                                                : null}
                                            <Box display="flex" justifyContent="flex-end" p={2}>
                                                {permissionList.isLeaveRequestApproveReject && selectedRows.length > 0 && leaveRequestData.length > 0 ?
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        style={{ marginLeft: 10 }}
                                                        className={classes.colorApprove}
                                                        onClick={() => handleOpenDialogApprove()}
                                                    >
                                                        Approve
                                                    </Button>
                                                    : null}
                                                {permissionList.isLeaveRequestApproveReject && selectedRows.length > 0 && leaveRequestData.length > 0 ?
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        style={{ marginRight: '1rem', marginLeft: 10 }}
                                                        className={classes.colorReject}
                                                        onClick={() => handleOpenDialog()}
                                                    >
                                                        Reject
                                                    </Button>
                                                    : null}
                                                <Dialog open={openApprove}
                                                    onClose={handleCloseDialogApprove}
                                                    maxWidth="sm" fullWidth>
                                                    <DialogTitle>Confirm Approve</DialogTitle>
                                                    <DialogContent>
                                                        <DialogContentText style={{ fontSize: '18px' }}>
                                                            Are you sure you want to Approve this request?
                                                        </DialogContentText>
                                                    </DialogContent>
                                                    <DialogActions>
                                                        <Button
                                                            onClick={() => trackPromise(handleApproveClick())}
                                                            color="primary" autoFocus>
                                                            Yes
                                                        </Button>
                                                        <Button
                                                            onClick={handleCloseDialogApprove}
                                                            color="primary">
                                                            No
                                                        </Button>
                                                    </DialogActions>
                                                </Dialog>
                                                <Dialog open={open}
                                                    onClose={handleCloseDialog}
                                                    maxWidth="sm" fullWidth>
                                                    <DialogTitle>Confirm Reject</DialogTitle>
                                                    <DialogContent>
                                                        <DialogContentText style={{ fontSize: '18px' }}>
                                                            Are you sure you want to Reject this request?
                                                        </DialogContentText>
                                                    </DialogContent>
                                                    <DialogActions>
                                                        <Button
                                                            onClick={() => trackPromise(handleReject())}
                                                            color="primary" autoFocus>
                                                            Yes
                                                        </Button>
                                                        <Button
                                                            onClick={handleCloseDialog}
                                                            color="primary">
                                                            No
                                                        </Button>
                                                    </DialogActions>
                                                </Dialog>
                                            </Box>
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Page>
        </Fragment >
    )
}